import { useEffect, useRef } from 'react'

export const ColumnItemWrapper: React.FC<ColumnItemWrapperProps> = ({
  children,
  divStyles = 'px-4 py-3',
  subElement = 'div', // div by default
  subElementStyle = 'text-xs text-primary-900 dark:text-white font-medium',
  floatingMenu,
}): JSX.Element => {
  const childrenExist = useRef(true)

  useEffect(() => {
    if (!children) {
      childrenExist.current = false
    }
  }, [children])

  const childElement = childrenExist.current ? children : null

  return (
    <>
      <div className={divStyles}>
        {subElement === 'paragraph' ? (
          <p
            className={subElementStyle}
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {childElement}
          </p>
        ) : (
          <>
            {subElement === 'div' ? (
              <div
                className={`${subElementStyle} ${
                  floatingMenu ? 'p-2 w-8 m-auto relative' : ''
                }`}
              >
                {childElement}
              </div>
            ) : (
              <>{childElement}</>
            )}
          </>
        )}
      </div>
    </>
  )
}

interface ColumnItemWrapperProps {
  children: React.ReactChild | any
  divStyles?: string
  subElement?: subElementType
  subElementStyle?: string
  floatingMenu?: boolean
}

type subElementType = 'paragraph' | 'div'
